/** Долгое нажатие.
 *
 * Нужно для клавиатуры: короткое касание ставит цифру, долгое — заметку.
 * Это привычный жест из большинства судоку, и он избавляет от постоянного
 * переключения режима ради одной пометки.
 */

import { useCallback, useRef } from 'react'

/** Четверть секунды: дольше — и жест начинает восприниматься как зависание. */
const LONG_PRESS_MS = 250
/** Смещение, после которого касание считается прокруткой, а не нажатием. */
const MOVE_TOLERANCE_PX = 10

export function useLongPress(
  onPress: () => void,
  onLongPress: () => void,
): {
  onPointerDown: (event: React.PointerEvent) => void
  onPointerUp: () => void
  onPointerMove: (event: React.PointerEvent) => void
  onPointerLeave: () => void
  onContextMenu: (event: React.MouseEvent) => void
} {
  const timer = useRef<number | null>(null)
  const fired = useRef(false)
  const origin = useRef({ x: 0, y: 0 })

  const cancel = useCallback(() => {
    if (timer.current !== null) {
      window.clearTimeout(timer.current)
      timer.current = null
    }
  }, [])

  return {
    onPointerDown: (event) => {
      fired.current = false
      origin.current = { x: event.clientX, y: event.clientY }
      timer.current = window.setTimeout(() => {
        fired.current = true
        onLongPress()
      }, LONG_PRESS_MS)
    },
    onPointerUp: () => {
      cancel()
      // Долгое нажатие уже отработало — короткое поверх него не нужно.
      if (!fired.current) onPress()
    },
    onPointerMove: (event) => {
      const moved =
        Math.abs(event.clientX - origin.current.x) > MOVE_TOLERANCE_PX ||
        Math.abs(event.clientY - origin.current.y) > MOVE_TOLERANCE_PX
      if (moved) {
        cancel()
        fired.current = true
      }
    },
    onPointerLeave: () => {
      cancel()
      fired.current = true
    },
    // Долгое нажатие на телефоне вызывает системное меню — оно тут мешает.
    onContextMenu: (event) => event.preventDefault(),
  }
}
